/**
 * Fade dinámico de carruseles móviles.
 *
 * El lado difuminado indica hacia dónde queda contenido:
 *   inicio → solo derecha · medio → los dos · final → solo izquierda
 *   todo cabe → sin fade
 *
 * El fade estático mentía en los extremos: al llegar al final seguía
 * difuminando la derecha, como si hubiera más, y cortaba a filo la izquierda.
 *
 * Cómo se usa: pon `data-ma-fade` en el contenedor que hace scroll horizontal.
 * Las máscaras viven en ma-base.css (clases ma-fade--*), solo dentro de
 * @media (max-width: 768px) — en desktop las clases no pintan nada.
 *
 * Sin JS el CSS deja el fade a la derecha, que es el estado inicial correcto.
 */
(function () {
  var ESTADOS = ['ma-fade--right', 'ma-fade--left', 'ma-fade--both', 'ma-fade--none'];
  var HOLGURA = 2; // subpíxeles y zoom

  function estado(el) {
    var max = el.scrollWidth - el.clientWidth;
    if (max <= HOLGURA) return 'ma-fade--none';
    var x = el.scrollLeft;
    if (x <= HOLGURA) return 'ma-fade--right';
    if (x >= max - HOLGURA) return 'ma-fade--left';
    return 'ma-fade--both';
  }

  function pintar(el) {
    var quiero = estado(el);
    if (el.classList.contains(quiero) && !sobra(el, quiero)) return;
    ESTADOS.forEach(function (c) {
      if (c !== quiero) el.classList.remove(c);
    });
    el.classList.add(quiero);
  }

  function sobra(el, quiero) {
    return ESTADOS.some(function (c) {
      return c !== quiero && el.classList.contains(c);
    });
  }

  var observados = new WeakSet();

  function conectar(el) {
    if (observados.has(el)) return;
    observados.add(el);

    // Cálculo directo (dos lecturas) en vez de diferirlo a requestAnimationFrame:
    // el rAF no corre de forma fiable en todos los contextos y el fade se
    // quedaba trabado en el estado inicial. `pintar` solo toca el DOM cuando el
    // estado realmente cambia — 3 o 4 veces por gesto, no por evento.
    el.addEventListener('scroll', function () {
      pintar(el);
    }, { passive: true });

    // El carrusel de ingredientes se llena por JS y los cross-sell cambian de
    // ancho al cargar imágenes: hay que recalcular cuando el contenido cambia.
    if (typeof ResizeObserver === 'function') {
      new ResizeObserver(function () {
        pintar(el);
      }).observe(el);
    }
    if (typeof MutationObserver === 'function') {
      new MutationObserver(function () {
        pintar(el);
      }).observe(el, { childList: true });
    }

    pintar(el);
  }

  function refresh() {
    var nodos = document.querySelectorAll('[data-ma-fade]');
    for (var i = 0; i < nodos.length; i++) {
      conectar(nodos[i]);
      pintar(nodos[i]);
    }
  }

  window.MaCarouselFade = { refresh: refresh };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refresh);
  } else {
    refresh();
  }
  window.addEventListener('load', refresh);
  window.addEventListener('resize', refresh);
})();
